<template>
  <div>
    <el-select :value="value" value-key="key" :placeholder="$t('table.type')" :size="size" @input="change($event)">
      <el-option label="----------" value="" />
      <el-option label="充值" value="recharge" />
      <el-option label="返佣" value="margin" />
      <el-option label="退款" value="refund" />
      <el-option label="停卡" value="deactive"/>
      <el-option label="激活卡" value="active"/>
      <el-option label="限速" value="restrict"/>
    </el-select>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/CardLogTypeSelect.vue